var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container fill-height",staticStyle:{"height":"calc(70vh)"}},[_c('v-row',{staticClass:"text-center align-center justify-center"},[_c('h2',[_vm._v("404 - Page Not Found")])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }